import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';

const ServiceCard = ({ icon, title, onClick }) => {
  return (
    <Card
      sx={{
        textAlign: 'center',
        py: 2,
        px:6,
        height: '100%',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: 3,
          transform: 'translateY(-2px)',
        },
      }}
      onClick={onClick}
    >
      <CardContent>
        <Box sx={{ mb: 2 }}>
          {icon}
        </Box>
        <Typography variant="h6" component="h3" sx={{textTransform: 'capitalize'}}>
          {title}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ServiceCard;